module.exports = __webpack_public_path__ + "img/export.37c8ba26.svg";